import apiCliente from '../utils/apiCliente';

/**
 * Obtiene el estado actual del token de Instagram
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Promise<Object>} Estado del token
 */
export const obtenerEstadoTokenInstagram = async (dispatch) => {
	try {
		const token = sessionStorage.getItem('token');

		if (!token) {
			throw new Error('No hay sesión activa');
		}

		const response = await apiCliente.get('/instagram-token', {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});

		return response.data;
	} catch (error) {
		console.error('Error al obtener estado del token de Instagram:', error);

		if (error.response?.status === 401) {
			// Token expirado, redirigir al login
			window.location.href = '/login';
		}

		throw new Error(error.response?.data?.error || 'Error al obtener estado del token de Instagram');
	}
};
